import axiosInstance from './axiosInstance'

export const getProjectShippingPOById = (id) => {
  return axiosInstance.get(`/project-shipping-pos/${id}`)
}

export const getProjectShippingPOsByProjectId = (projectId) => {
  return axiosInstance.get(`/project-shipping-pos/?projectId=${projectId}`)
}

// export const getProjectShippingPOs = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
//   return axiosInstance.get(`/project-shipping-pos?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
// }

export const createProjectShippingPO = (data) => {
  return axiosInstance.post('/project-shipping-pos', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const updateProjectShippingPO = (id, data) => {
  return axiosInstance.put(`/project-shipping-pos/${id}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const deleteProjectShippingPO = (id) => {
  return axiosInstance.delete(`/project-shipping-pos/${id}`)
}

export const generateProjectShippingLabel = (id) => {
  return axiosInstance.get(`/project-shipping-pos/label/${id}`)
}
